import Phaser from "phaser";
import { formatFloatVar } from "../view/display-format";
import type { VfxFloatTextPreset } from "./types";
import { allocateFloatScatter } from "./float-text-scatter";

export function playFloatText(
  scene: Phaser.Scene,
  x: number,
  y: number,
  preset: VfxFloatTextPreset,
  vars: Record<string, string | number> = {},
  depth?: number,
): void {
  const raw = preset.template;
  if (typeof raw !== "string" || raw.length === 0) {
    console.warn("[vfx] floatText missing template");
    return;
  }
  const text = raw.replace(/\{(\w+)\}/g, (_, k: string) => {
    const v = vars[k];
    if (v === undefined) return `{${k}}`;
    return formatFloatVar(k, v);
  });
  const color =
    typeof vars.color === "string" && vars.color.length > 0
      ? vars.color
      : preset.color;
  const oy = preset.offsetY ?? 0;
  const baseX = x;
  const baseY = y + oy;
  const now =
    typeof scene.time?.now === "number" && Number.isFinite(scene.time.now)
      ? scene.time.now
      : Date.now();
  const { dx, dy } = allocateFloatScatter(baseX, baseY, now, preset.duration);
  // Whole px + modest resolution — FIT scale-down softens bitmap text less.
  const sx = Math.round(baseX + dx);
  const sy = Math.round(baseY + dy);
  const fontPx = Math.max(14, Math.round(preset.fontSize ?? 16));
  const dpr =
    typeof window !== "undefined" && Number.isFinite(window.devicePixelRatio)
      ? Math.min(2, Math.max(1, window.devicePixelRatio))
      : 1;
  const label = scene.add
    .text(sx, sy, text, {
      fontFamily: "Malgun Gothic, sans-serif",
      fontSize: `${fontPx}px`,
      color,
      fontStyle: "bold",
      stroke: preset.stroke ?? "#000000",
      strokeThickness: preset.strokeThickness ?? 3,
      resolution: dpr,
    })
    .setOrigin(0.5)
    .setDepth(depth ?? 6);
  scene.tweens.add({
    targets: label,
    y: sy - preset.rise,
    alpha: 0,
    duration: preset.duration,
    onComplete: () => {
      if (label.active) label.destroy();
    },
  });
}
